import { Skeleton } from "@mui/material";

interface TableRowsSkeletonProps {
  isDarkMode: boolean;
  rows?: number;
  columns: number;
  firstColumnWidth?: string;
}

export default function TableRowsSkeleton({ isDarkMode, rows = 6, columns, firstColumnWidth = "70%" }: TableRowsSkeletonProps) {
  const skeletonColor = isDarkMode ? { bgcolor: "grey.900" } : {};
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex} className={`border-t ${isDarkMode ? "border-gray-800" : "border-gray-100"}`}>
          {Array.from({ length: columns }).map((__, colIndex) => (
            <td key={colIndex} className="px-3 py-3">
              <Skeleton
                width={colIndex === 0 ? firstColumnWidth : `${55 + ((rowIndex + colIndex) % 4) * 10}%`}
                height={14}
                animation="wave"
                sx={skeletonColor}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
